import { Elastic, gsap } from 'gsap';

import type { gsapTimelineFunc } from '../gsap-config';

export const backInDown: gsapTimelineFunc = (targets) => {
  return gsap
    .timeline({ defaults: { ease: Elastic.easeOut.config(1, 0.3) } })
    .fromTo(
      targets,
      {
        duration: 0,
        scale: 0.7,
        opacity: 0,
        translate: '0px -1200px 0px',
        transformOrigin: 'center center',
      },
      {
        duration: 0.1,
        scale: 0.7,
        opacity: 1,
        translate: '0px -100px 0px',
      }
    )
    .to(targets, {
      duration: 0.4,
      scale: 0.7,
      translate: '0px 0px 0px',
    })
    .to(targets, {
      duration: 0.5,
      scale: 1,
      translate: '0px 0px 0px',
      stagger: { amount: 0.5 },
    });
};
